@if (!authenticated()) {
  <app-default-layout></app-default-layout>
}
@if (authenticated()) {
  <app-logged-layout></app-logged-layout>
}
